import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/09fba966-484d-433a-b1bf-c0878863906c";
export const REGISTER_URL = "https://a.ntrk2.com/eb7d5006-bbfb-4799-a1ee-55d1f29b7c35";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://maxpe.loadprkw2a.com/download?openExternalBrowser=1&id=lqew9f77binv0yr";

export * from "./codes";
export * from "./context";
